import TableCard from 'components/organisms/Admin/AnswerDetail/TableCard'
import React from 'react'

const AnswerDetail: React.VFC = () => {
  return <TableCard />
}

export default AnswerDetail
